import {useGetAutoDeliveryDetailsDcx} from '@/api/consumerApi';
import appContent from '@/services/content/appContent.typed';
import {AUTO_DELIVERY_INFO_BOX_SOURCES} from '@/types/content';
import {twx} from '@/utils/tailwindUtils';
import {isActiveOutOfStockOnHold} from '@/views/AutoDeliveryDcx/AutoDeliveryDcxActive/autoDeliveryDcxActive.helpers';
import {AutoDeliveryDcxActiveInfoBox} from '@/views/AutoDeliveryDcx/AutoDeliveryDcxActive/AutoDeliveryDcxActiveInfoBox';
import AutoDeliveryDcxDeliveryWindowLabel from '@/views/AutoDeliveryDcx/AutoDeliveryDcxActive/AutoDeliveryDcxDeliveryWindowLabel';
import AutoDeliveryDcxNextDeliveryDateRangeTitle from '@/views/AutoDeliveryDcx/AutoDeliveryDcxActive/AutoDeliveryDcxNextDeliveryDateRangeTitle';
import AutoDeliveryDcxNextDeliveryTitle from '@/views/AutoDeliveryDcx/AutoDeliveryDcxActive/AutoDeliveryDcxNextDeliveryTitle';
import AutoDeliveryDcxDeliveryStepper from '@/views/AutoDeliveryDcx/AutoDeliveryDcxDeliveryStepper/AutoDeliveryDcxDeliveryStepper';

import AutoDeliveryDcxOrderLabel from './components/AutoDeliveryDcxOrderLabel';
import AutoDeliveryDcxWidgetContainer from './components/AutoDeliveryDcxWidgetContainer';
import AutoDeliveryDcxWidgetHeader from './components/AutoDeliveryDcxWidgetHeader';

type AutoDeliveryDcxStatusActiveWidgetProps = {
    className?: string;
};

const AutoDeliveryDcxStatusActive = ({className}: AutoDeliveryDcxStatusActiveWidgetProps) => {
    const {data} = useGetAutoDeliveryDetailsDcx();
    const {nextDeliveryLabel} = appContent.getAutoDeliveryContent()?.dashboardContent || {};

    const {
        autoDelivery: {
            minDeliveryDaysCount,
            maxDeliveryDaysCount,
            nextDeliveryDate,
            maxNextDeliveryDate,
            status,
            statusUpdateReason,
        },
        order: {status: orderStatus, orderId},
    } = data;

    const isOutOfStockOnHold = isActiveOutOfStockOnHold(statusUpdateReason);

    return (
        <AutoDeliveryDcxWidgetContainer className={className}>
            <AutoDeliveryDcxWidgetHeader orderId={orderId} />
            <AutoDeliveryDcxWidgetContainer.ContentContainer className='md:mt-8 md:rounded-3xl md:bg-romance md:px-6 md:py-8'>
                {orderId && (
                    <div className='hidden md:mb-4 md:block'>
                        <AutoDeliveryDcxOrderLabel orderId={orderId} />
                    </div>
                )}
                <div className='flex flex-col gap-4 rounded-xl bg-primary-dark-5 p-4'>
                    {!isOutOfStockOnHold && (
                        <div className='flex flex-col gap-1'>
                            <AutoDeliveryDcxNextDeliveryTitle nextDeliveryDate={nextDeliveryDate} />
                            <AutoDeliveryDcxNextDeliveryDateRangeTitle
                                className='text-18 leading-[24px]'
                                nextDeliveryDate={nextDeliveryDate}
                                maxNextDeliveryDate={maxNextDeliveryDate}
                            />
                            <AutoDeliveryDcxDeliveryWindowLabel
                                label={nextDeliveryLabel}
                                minDeliveryDaysCount={minDeliveryDaysCount}
                                maxDeliveryDaysCount={maxDeliveryDaysCount}
                            />
                        </div>
                    )}
                    <AutoDeliveryDcxActiveInfoBox
                        details={data}
                        source={AUTO_DELIVERY_INFO_BOX_SOURCES.DASHBOARD}
                        className={twx(
                            'border-t border-solid border-mischka p-0 pt-4',
                            isOutOfStockOnHold && 'border-t-0 pt-0'
                        )}
                    />
                </div>
                <AutoDeliveryDcxDeliveryStepper
                    status={status}
                    statusUpdateReason={statusUpdateReason}
                    orderStatus={orderStatus}
                    className='mt-4'
                />
            </AutoDeliveryDcxWidgetContainer.ContentContainer>
        </AutoDeliveryDcxWidgetContainer>
    );
};

export default AutoDeliveryDcxStatusActive;
